import { ControlShowHiddenRule } from '../components/show-hidden/show-hidden-rule';
import {
  AbstractControl,
  AbstractValueControlBase,
  ControlViewModel,
  DynamicForm,
  ValueControlViewModel
} from '../types';
import { ShowHiddenRuleModel } from '../types/control-show-hidden.types';
import { findControlByName, controlsTraversalPipe } from '../utils';
import { DynamicFormRunHelperService } from './services/dynamic-form-run-helper.service';

export abstract class AbstractDynamicForm implements DynamicForm {
  formCode?: string;
  labelCode?: string;
  targetId?: string;
  controls: AbstractControl<ControlViewModel>[];

  private _showHiddenRules: ControlShowHiddenRule[] = [];

  /**
   * è®¾ç½®æ§ä»¶æä½æ¨¡å¼
   */
  abstract setControlOperateMode(control: AbstractControl<any>): void;

  // æ¸ç©ºè¡¨å
  clear(runHelperService: DynamicFormRunHelperService) {
    controlsTraversalPipe(this.controls, (c) => {
      runHelperService.setControlValue(c, { controlsData: {} }, this.targetId);
      if (c instanceof AbstractValueControlBase) {
        // çº§èä¸èèï¼æææ§ä»¶é½ä¼è¢«æ¸ç©ºå¼
        // ä½æ¯æ¾éè§æ ¼ä¾èµå¼ååäºä»¶ï¼ææè¿ééè¦å¹¿æ­ä¸ä¸å¼æ¹åäºä»¶
        c.broadValueChange();
      }
    });
  }

  /**
   * è®¾ç½®æ§ä»¶éè
   */
  setControlHiddenByName(name: string, isHidden: boolean): void {
    const control = this.findControlByName(name);
    this.setControlHidden(control, isHidden);
  }

  setControlHidden(control: AbstractControl<ControlViewModel>, isHidden: boolean) {
    const clearDataWhenHidden = (control.model as ValueControlViewModel).clearDataWhenHidden;
    if (isHidden) {
      // éèæ¶æ ¡éªä¿¡æ¯å¨è·åéªè¯ç¶ææ¶å·²ç»å äºå¤æ­ï¼è¿éä¸éè¦å¤ç

      if (clearDataWhenHidden) {
        control.setModelValue(undefined);
        const valueControl = control as AbstractValueControlBase<ValueControlViewModel>;
        if (valueControl.broadControlValueChange) {
          valueControl.broadControlValueChange();
        }
      }
    } else {
      if (control.hidden) {
        control.validate();
      }
    }

    control.hidden = isHidden;
  }

  bindShowHiddenRule(showHiddenRuleModels: ShowHiddenRuleModel[]): void {
    if (!showHiddenRuleModels) {
      return;
    }
    // åæ¸ç©ºï¼é¿åå¤éç»å®
    this._showHiddenRules.map((s) => s.unBind());
    this._showHiddenRules.length = 0;

    this._showHiddenRules = showHiddenRuleModels.map((s) => {
      const rule = new ControlShowHiddenRule();
      Object.assign(rule, s);
      rule.controls = this.controls;
      rule.dynamicForm = this;
      rule.bind();
      return rule;
    });
  }

  /**
   * è§¦åé»è®¤çº§è
   */
  triggerDefaultCascade() {
    controlsTraversalPipe(this.controls, (c) => {
      if (c instanceof AbstractValueControlBase && c.onDefaultCascadeValueChange) {
        c.onDefaultCascadeValueChange();
      }
    });
  }

  /**
   * æ ¹æ®æ§ä»¶åç§°æ¥æ¾æ§ä»¶
   */
  findControlByName(name: string): AbstractControl<ControlViewModel> {
    return findControlByName(name, this.controls);
  }
}
